import { IRootState } from 'affiny-core/modules/state';
import get from 'lodash/get';

export const selectNbFavorites = (state: IRootState) =>
  state.favorites.nbFavorites;

/* ***** *****  Received  ***** ***** */

export const selectReceivedFavoritesTotal = (
  state: IRootState
): number | undefined => get(state, 'favorites.received.meta.total');

export const selectReceivedFavoritesCurrentPage = (state: IRootState): number =>
  state.favorites.received.meta.currentPage;

export const selectReceivedFavoritesList = (state: IRootState): string[] =>
  get(state, 'favorites.received.list');

/* ***** *****  Sent  ***** ***** */

export const selectSentFavoritesTotal = (
  state: IRootState
): number | undefined => get(state, 'favorites.sent.meta.total');

export const selectSentFavoritesCurrentPage = (state: IRootState): number =>
  state.favorites.sent.meta.currentPage;

export const selectSentFavoritesList = (state: IRootState): string[] =>
  get(state, 'favorites.sent.list');
